import React from "react";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {ReportChartComponent} from "../types/report.chart.component";
import {useAppStore} from "../../../common/app.store.consumer";
import {ChartTypes} from "../types/report.chart.types";

const ReportChartSelector: React.FC<ReportChartComponent> = useAppStore()((props: ReportChartComponent) => {
	const store = props.appStore.reportPageStore;

	return (
		<div className="cih-flex cih-flex-col cih-ml-auto cih-hide-print">
			<div className="cih-chart-selector cih-flex">
				<button onClick={() => store.setReportChartType(ChartTypes.BarChart)} className={"cih-btn " + ((store.reportChartType === ChartTypes.BarChart) ? "active" : "")}>
					<FontAwesomeIcon icon={["fas", "align-left"]} />
					<span>Bars</span>
				</button>
				<button onClick={() => store.setReportChartType(ChartTypes.SpiderWebChart)} className={"cih-btn " + ((store.reportChartType === ChartTypes.SpiderWebChart) ? "active" : "")}>
					<FontAwesomeIcon icon={["fas", "bullseye"]} />
					<span>Radar</span>
				</button>
			</div>
		</div>
	);
});

export default ReportChartSelector;
